import * as React from 'react';
import Select from 'react-select';
import { useToken } from '@chakra-ui/react';

const CustomSelect = ({
  height = 48,
  borderColor = '',
  indicatorSeparatorColor = '',
  isClearable = false,
  isDisabled = false,
  isMulti = false,
  isSearchable = false,
  menuPlacement = 'bottom',
  onChange,
  placeholder = '',
  options = [],
  value,
  width = null,
  maxWidth = 340,
  inputRef = undefined,
  onBlur = undefined,
}) => {
  const [
    muted100,
    primary50,
    primary100,
    primary800,
    secondary100,
    secondary500,
  ] = useToken('colors', [
    'muted.100',
    'primary.50',
    'primary.100',
    'primary.800',
    'secondary.100',
    'secondary.500',
  ]);

  return (
    <Select
      isClearable={isClearable}
      isDisabled={isDisabled}
      isMulti={isMulti}
      isSearchable={isSearchable}
      menuPlacement={menuPlacement}
      menuPortalTarget={document.body}
      menuShouldScrollIntoView={false}
      options={options}
      onChange={onChange}
      placeholder={placeholder}
      onBlur={onBlur}
      styles={{
        menuPortal: (base) => ({
          ...base,
          fontSize: '14px',
          maxWidth,
          zIndex: 9999,
        }),
        container: (base) => ({
          ...base,
          width,
        }),
        control: (base, state) => ({
          ...base,
          fontSize: '14px',
          height,
          maxWidth,
          borderColor,
          backgroundColor: state.isDisabled
            ? muted100
            : base.backgroundColor,
        }),
        indicatorSeparator: (base) => ({
          ...base,
          backgroundColor: indicatorSeparatorColor,
        }),
        valueContainer: (base) => ({
          ...base,
          overflowY: 'auto',
          width: '100%',
          height: '100%',
        }),
      }}
      theme={(theme) => ({
        ...theme,
        borderRadius: 4,
        colors: {
          ...theme.colors,
          neutral20: secondary500,
          neutral30: secondary100,
          primary: primary800,
          primary25: primary50,
          primary50: primary100,
        },
      })}
      value={value}
      ref={inputRef}
    />
  );
};

export { CustomSelect as Select };
